/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import {
  Box,
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
} from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import NotificationItem from "examples/Items/NotificationItem";

import { URL_API } from "config";

import MDInput from "components/MDInput";
import { useAuthContext } from "context/AuthContext";

function CooperatedTable() {
  const [cooperateds, setCooperateds] = useState([]);

  const [rowSelected, setRowSelected] = useState();

  const [loading, setLoading] = useState(false);
  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  const [status, setStatus] = useState(4);
  const [filter, setFilter] = useState();

  const navigate = useNavigate();

  let tag = localStorage.getItem("Tag");

  const { user } = useAuthContext();

  const dataTableData = {
    columns: [
      { Header: "Criação", accessor: "createdAt" },
      { Header: "Atualização", accessor: "updatedAt" },
      { Header: "Nome", accessor: "full_name" },
      { Header: "Número Conta", accessor: "account_number" },
      { Header: "CPF", accessor: "cpf" },
      { Header: "Telefone", accessor: "phone" },
      { Header: "Email", accessor: "email" },
      { Header: "StatusCooperated", accessor: "status" },
      { Header: "UUID", accessor: "uuid" },
      { Header: "Ações", accessor: "action", width: "7%" },
    ],
    rows: cooperateds,
  };

  const stts = [
    { name: "Todos", id: 0 },
    { name: "Em Aberto", id: 1 },
    { name: "Iniciado", id: 2 },
    { name: "Em Análise", id: 3 },
    { name: "Pendência Documentos", id: 4 },
    { name: "Em Processo de Admissão", id: 5 },
    { name: "Aprovado", id: 6 },
    { name: "Reprovado", id: 7 },
    { name: "Aguardando Assinatura", id: 8 },
    { name: "Pendente Envio Empresa", id: 9 },
    { name: "Finalização Cadastral", id: 10 },
  ];

  useEffect(() => {
    (async () => {
      setLoading(true);

      if (user?.company_id) await getCooperateds(tablePage, tableLimit);

      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.company_id, tablePage, tableLimit]);

  async function getCooperateds(page = 1, limit = 10) {
    await axios
      .get(
        URL_API +
          `/cooperateds?page=${page}&limit=${limit}` +
          `${filter ? `&filter=${filter}` : ""}` +
          `${status ? `&status=${status}` : ""}` +
          `${user?.company_id ? `&company_id=${user?.company_id}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        for (const data of response?.data.data) {
          Object.assign(data, {
            createdAt: new Date(data.created_at).toLocaleDateString("pt-BR"),
            updatedAt: new Date(data.updated_at).toLocaleDateString("pt-BR"),
          });
        }

        setCooperateds(response.data.data);
        setTableTotal(response?.data.meta?.total);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtros para Colaboradores
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container>
                  <Grid item>
                    <MDInput
                      label="Buscar por colaborador..."
                      onChange={async (event) => setFilter(event.target.value)}
                      size="large"
                    />
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <FormControl sx={{ width: 190 }}>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={status}
                        label="Status"
                        sx={{ height: "45px" }}
                        onChange={(value) => setStatus(value.target.value)}
                      >
                        {stts.map((s) => {
                          return <MenuItem value={s.id}>{s.name}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <IconButton
                      onClick={async () =>
                        await getCooperateds(tablePage, tableLimit)
                      }
                      sx={{
                        color: "#fff",
                        background: "#3f50b5",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Colaboradores
                </MDTypography>

                <MDButton
                  color="light"
                  onClick={() => {
                    navigate("/admin/cooperateds/create");
                  }}
                >
                  Criar Cadastro
                </MDButton>
              </MDBox>
              {loading ? (
                <Box sx={{ width: "100%" }}>
                  <LinearProgress sx={{ overflow: "hidden" }} />
                </Box>
              ) : (
                <DataPaginateTable
                  entriesPerPage={{ defaultValue: tableLimit }}
                  table={dataTableData}
                  onRowSelected={setRowSelected}
                  setTableLimit={setTableLimit}
                  tableLimit={tableLimit}
                  setTablePage={setTablePage}
                  tablePage={tablePage}
                  tableTotal={tableTotal}
                >
                  {[
                    <NotificationItem
                      onClick={() => {
                        navigate(
                          "/admin/cooperateds/update/" +
                            rowSelected.original.uuid
                        );
                      }}
                      icon={<Icon>create</Icon>}
                      title="Editar"
                    />,
                  ]}
                </DataPaginateTable>
              )}
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default CooperatedTable;
